module.exports = __webpack_public_path__ + "static/img/l_mk.8c9f8602.png";